module.exports = __webpack_public_path__ + "img/click.89eeca27.png";